// HR-module shared helpers.
//
// DOB redaction: list views show "MMM d" only (no year). The detail view
// has a per-row "Show full DOB" toggle gated to hr/executive/superuser.

export function fmtMonthDay(d: string | null | undefined): string {
  if (!d) return '';
  const dt = new Date(d + 'T00:00:00Z');
  if (Number.isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

export function fmtMonthDayYear(d: string | null | undefined): string {
  if (!d) return '';
  const dt = new Date(d + 'T00:00:00Z');
  if (Number.isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function yearsSince(d: string | null | undefined): number | null {
  if (!d) return null;
  const start = new Date(d + 'T00:00:00Z');
  if (Number.isNaN(start.getTime())) return null;
  const now = new Date();
  let years = now.getUTCFullYear() - start.getUTCFullYear();
  const m = now.getUTCMonth() - start.getUTCMonth();
  if (m < 0 || (m === 0 && now.getUTCDate() < start.getUTCDate())) years -= 1;
  return Math.max(years, 0);
}

// ⛔ The COI traffic-light lived here (CoiStatus, COI_DOT_CLASS, and before that
// a coiStatus(date) helper on its own 30/60-day thresholds). All of it is gone:
// its only two callers were the unrouted HR pages deleted 2026-08-24, and the
// named COI states now come from v_provider_compliance_status through
// src/shared/coi-state.ts (TCSD-0103/0104). Do not reintroduce a local
// derivation of insurance state.
